module.exports = __webpack_public_path__ + "assets/img/pop-foto.d7f56037.jpg";